import { useState } from 'react';
import { faqs } from '@/mocks/home';
import SectionHeading from '@/pages/home/components/SectionHeading';

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="scroll-mt-24 border-b border-background-200 bg-background-100">
      <div className="mx-auto max-w-[1400px] px-4 py-14 md:px-6 md:py-20">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-14">
          <div data-reveal className="lg:col-span-4">
            <SectionHeading
              index="06"
              eyebrow="常见问题"
              title="关于撸撸射入口，你可能想问"
              desc="把大家最常遇到的疑问集中解答，如果还有没覆盖到的情况，可以参考访问指南逐条尝试。"
            />
            <div className="mt-8 rounded-lg border border-background-300 bg-background-50 p-5">
              <p className="text-xs font-semibold tracking-[0.2em] text-accent-700">还在找入口？</p>
              <p className="mt-2 text-sm leading-6 text-foreground-600">
                收藏本页并记住可用线路，下次访问就不用再重新搜索了。
              </p>
            </div>
          </div>

          <div data-reveal className="lg:col-span-8">
            <div className="overflow-hidden rounded-lg border border-background-300 bg-background-50">
              {faqs.map((item, i) => {
                const isOpen = openIndex === i;
                return (
                  <div key={item.q} className="border-b border-background-200 last:border-b-0">
                    <button
                      type="button"
                      onClick={() => setOpenIndex(isOpen ? null : i)}
                      aria-expanded={isOpen}
                      className="flex w-full cursor-pointer items-center gap-4 px-5 py-5 text-left transition-colors hover:bg-background-100 md:px-6"
                    >
                      <span className="font-heading text-sm font-black text-accent-600">
                        {String(i + 1).padStart(2, '0')}
                      </span>
                      <span className="flex-1 font-heading text-base font-bold text-foreground-950 md:text-lg">
                        {item.q}
                      </span>
                      <i
                        className={isOpen ? 'ri-subtract-line text-xl text-foreground-600' : 'ri-add-line text-xl text-foreground-600'}
                        aria-hidden="true"
                      ></i>
                    </button>
                    {isOpen ? (
                      <div className="px-5 pb-6 pl-14 md:px-6 md:pl-16">
                        <p className="text-sm leading-7 text-foreground-600">{item.a}</p>
                      </div>
                    ) : null}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}